<template>
    <v-dialog v-model="dialog" max-width="1200" persistent>
        <v-card>
            <v-container>
                <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary accent-4"></v-progress-linear>
                <diagnostic-results-mobile
                    v-if="sizeMobile"
                    :assesmentFlag="true"
                    :data="currentResult"
                    @close="dialog = false"

                />
                <DiagnosticResults
                    v-else
                    :data="currentResult"
                    :results="results"
                    :dialog="true"
                    :loading="loading"
                    @update="setCurrentResult"
                    @close="dialog = false"
                />
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DiagnosticResults from '../../../LkStudents/DiagnosticTest/DiagnosticResults/index.vue';
import DiagnosticResultsMobile from '../../../LkStudents/DiagnosticTest/DiagnosticResults/indexMobile.vue';

export default {
    components: { DiagnosticResults, DiagnosticResultsMobile },
    data: () => ({
        results: [],
        currentResult: {},
        dialog: false,
        loading: false,
        correctlyAnswered: [
            'Это верный ответ!',
            'Правильно!',
            'Отлично! Продолжайте!',
            'Превосходно!',
            'Замечательно!',
            'Это фантастика! Великолепный результат!',
            'Искусственный интеллект аплодирует вам!',
            'Впечатляет!!!',
            'Отлично! Не все знают ответ на этот вопрос!',
            'Вы на пути к триумфу!'
        ],
        wrongAnswer: [
            'К сожалению, это неверно.',
            'Жаль! Вы были близки к правильному ответу.',
            'Неправильно. Придется повторить материал.',
            'А вы точно это учили?',
            'Соберитесь! Вы теряете баллы!',
            'Может, со следующим вопросом получится лучше?',
            'А вот и нет!',
            'Неверно! Надо бы повторить эту тему.',
            'Каждая ваша ошибка причиняет мне боль. Не делайте так!',
            'Ошибаться - это нормально, но впредь будьте внимательнее.'
        ],
    }),
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl'
        }),
        sizeMobile(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return true
                default:
                    return false
            }
        },
    },
    methods: {
        ...mapActions({
            getDiaTestProcessResult: 'takeDiagnosticTest/getDiaTestProcessResult'
        }),
        reset(input) {
            this.dialog = false;
            this.loading = false;

            this.loadResults(input);
        },

        loadResults(input) {
            this.loading = true;

            let action = input.assignId !== null ?
                `GetDiaTestResults?assignId=${input.assignId}` :
                `GetDiaTestReportResults?testId=${input.testId}&userId=${input.userId}`;

            this.$http.get(`${this.apiUrl}DiaTestProcess/${action}`)
                .then((response) => {
                    this.results = response.data;
                    this.loading = false;

                    if (input.resultId !== null && this.results.find(x => x.id === input.resultId) !== undefined) {
                        this.loadResult(input.resultId);
                    }
                    else if (this.results.length > 0) {
                        this.loadResult(this.results[0].id);
                    } else {
                        this.$emit('loaded');
                    }
            });
        },
        getTextByResult(score) {
            let name = '', index = 0;

            if(score <= 0) name = 'wrongAnswer'
            if(score >= 1) name = 'correctlyAnswered'

            index = Math.floor(Math.random() * this[name].length);

            return this[name][index]
        },
        loadResult(id) {
            this.loading = true;

            this.getDiaTestProcessResult(id)
                .then((data) => {
                    for (let i = 0; i < data.criteries.length; i++) {
                        this.$set(data.criteries[i], 'isOpen', false);
                        this.$set(data.criteries[i], 'showAnswer', false);
                        
                        data.criteries[i].scoreText = this.getTextByResult(data.criteries[i].score);

                        if(data.criteries[i].title === 'Время диагностики'){
                            data.criteries[i].result = data.timer
                        }
                        if(data.criteries[i].title === 'Алгоритм действий'){
                            data.criteries[i].result = data.correctSections
                        }
                        if(data.criteries[i].title === 'Постановка синдромального диагноза'){
                            data.criteries[i].result = data.correctSyndromicDiagnoses
                        }
                        if(data.criteries[i].title === 'Постановка предварительного диагноза'){
                            data.criteries[i].result = data.correctPreliminaryDiagnoses
                        }
                        if(data.criteries[i].title === 'Постановка окончательного диагноза'){
                            data.criteries[i].result = data.correctFinalDiagnoses
                        }
                        if(data.criteries[i].title === 'Выбор лабораторных исследований'){
                            data.criteries[i].result = data.correctLabResearches
                        }
                        if(data.criteries[i].title === 'Выбор инструментальных исследований'){
                            data.criteries[i].result = data.correctInstrumentalResearches
                        }
                        if(data.criteries[i].title === 'Определение патологии'){
                            data.criteries[i].result = data.correctPathologies
                        }
                    }
                    this.currentResult = data;
                    
                    // console.log(this.currentResult);

                    this.currentResult.id = this.currentResult.processId;

                    this.loading = false;
                    this.dialog = true;
                    this.$emit('loaded');
                });
        },
        setCurrentResult(id) {
            this.loadResult(id);
        },
        close() {
            this.dialog = false;
            this.$emit('close');
        }
    }
}
</script>
